import { useMergedStyles } from '#src/hooks';

import { Checkbox } from '../../Form/Checkbox';
import BraintreeDropIn from '../BraintreeDropIn';

import localStyles from './styles.module.scss';

export default function Payment({
  amountDue,
  isAdHocMembershipOrder,
  requiresStoreInVault,
  savePaymentLabel,
  setBraintreeInstance,
  setPaymentMethodReady,
  storeInVault,
  parentStyles,
  theme,
  token,
}) {
  const styles = useMergedStyles(localStyles, parentStyles);
  const handlePaymentMethodRequestable = (event) => {
    setPaymentMethodReady(true, event);
  };

  return (
    <div className={styles.container}>
      <div className={styles.dropInContainer}>
        {!!token && (
          <BraintreeDropIn
            token={token}
            amountDue={amountDue}
            onInstance={setBraintreeInstance}
            onNoPaymentMethodRequestable={() => setPaymentMethodReady(false)}
            onPaymentMethodRequestable={handlePaymentMethodRequestable}
            theme={theme}
          />
        )}
      </div>
      {!isAdHocMembershipOrder && (
        <label className={styles.savePayment}>
          <Checkbox
            name="storeInVault"
            disabled={requiresStoreInVault}
            checked={storeInVault}
          />
          <span className={styles.savePaymentLabel}>{savePaymentLabel}</span>
        </label>
      )}
    </div>
  );
}
